import App from './App';

const WithoutTypeScriptApp = (props: any) => <App />;

export default WithoutTypeScriptApp;